import React from "react"
import { Button, ButtonProps, IconBack } from "dash-styled"

type PrevButtonProps = Omit<ButtonProps, "variant" | "color" | "children">

export function PrevButton({ className, ...props }: PrevButtonProps) {
    return (
        <Button
            variant="round"
            color="gray"
            size="sm"
            className={`border-white border-rhino-500 text-rhino-200 bg-transparent ${className}`}
            {...props}
        >
            <IconBack size={props.size !== undefined ? props.size : "md"} />
        </Button>
    )
}
